import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_RESIT_CHECK_ELIGIBILITY} from '../../constants/apiUrls';
import {GenericErrorResponse} from '../../api';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CandidateEligibilityRequest {
  accessLink: boolean;
}

export interface ResitEligibilityResponse {
  eligible: boolean;
  error: GenericErrorResponse;
  draftExist: boolean;
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ResitEligibilityResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCheckEligibility = ({onSuccess, onError}: Input = {}) => {
  const postCheckEligibility = async (candidateEligibilityRequest: CandidateEligibilityRequest) => {
    const res = await axiosClient.post<ResitEligibilityResponse>(
        POST_RESIT_CHECK_ELIGIBILITY,
        candidateEligibilityRequest
    );
    return res.data;
  };

  return useCustomMutation(postCheckEligibility, {
    onSuccess,
    onError,
  });
};
